import React, {useState} from 'react'
import Navbar from './Navbar.js';
import './css/connect.css'

const Connect = () => {

    const [name, setName]=useState('');
    const [phone, setPhone]=useState('');
    const [email, setEmail]=useState('');
    const [address, setAddress]=useState('');
    const [message, setMessage]=useState('');


    const submitMessage = async (e) => {
        e.preventDefault()
        const response = await fetch('https://jivichem.herokuapp.com/api/v1/message/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                name,
                phone,
                email,
                address,
                message
            }),
        })

        const data = await response.json()
        if(data.success===true){
            alert("Message Send Sussecfully")
        }else{
            alert("error")
        }
    }



    return (
        <>
            <Navbar />

            <section className="lower-half">

                <div className="container">
                    <div className="row">
                        <div className="col">

                            <div className="main-registered-office">
                                <div className="image">
                                    <img src="map.png" alt="" width="100%" />
                                </div>

                                <div className="content">
                                    <h3 className="head-office-address">Registered Office</h3>
                                    <hr />
                                    <p>Jivichem Synthesis Pvt. Ltd</p>
                                    <p>107,</p>
                                    <p>Shesh nagar,manish layout,Anusaya,</p>
                                    <p>Mata kirana store,kharbi,watoda,</p>
                                    <p>Nandanwan,</p>
                                    <p>Nagpur,</p>
                                    <p>Maharashtra-440001</p>
                                    <p>Phone: +91-040- 2717 8571,</p>

                                    <iframe title="registered office" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.556750274488!2d79.12921466424714!3d21.130230589683954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c75c2be54b11%3A0x1860a5cf9ea77f35!2sShesh%20Nagar%2C%20Shaktimata%20Nagar%2C%20Kharbi%2C%20Nagpur%2C%20Maharashtra%20440024!5e0!3m2!1sen!2sin!4v1653960423974!5m2!1sen!2sin"
                                        width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>

                        </div>
                        <div className="col">
                            <div className="main-corporate-office">
                                <div className="image">
                                    <img src="map.png" alt="" width="100%" />
                                </div>
                                <div className="content">
                                    <h3 className="head-office-address">Corporate Office</h3>
                                    <hr />
                                    <p>Jivichem Synthesis Pvt. Ltd</p>
                                    <p>Vazhra Nirmann Pushpak,</p>
                                    <p>Flat No. 503,</p>
                                    <p>C Block,</p>
                                    <p>Madhura Nagar, Nizampet,</p>
                                    <p>Hyderabad, 500090</p>
                                    <p>Phone: +91-040- 2717 5796 / 2715 0423,</p>
                                    <iframe title="corporate office" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d487375.2712170466!2d78.15720683259968!3d17.382042285504305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91ed6897af17%3A0x438d7d029413ee11!2sVazhraa%20Nirmaan%20Prathik!5e0!3m2!1sen!2sin!4v1653954256642!5m2!1sen!2sin"
                                        width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className="chart">
                    <form>
                        <table>
                            <tr>
                                <td>
                                    <h3>Quick Contact</h3>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    Contact us today, and get reply with in 24 hours!
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <input type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e)=>setName(e.target.value)}
                                        placeholder="Your Name*" />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <input type="text"
                                        id="phone"
                                        value={phone}
                                        onChange={(e)=>setPhone(e.target.value)}
                                        placeholder="Your Contact Number*" />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <input type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e)=>setEmail(e.target.value)}
                                        placeholder="Your email address*" />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <input type="text"
                                        id="address"
                                        value={address}
                                        onChange={(e)=>setAddress(e.target.value)}
                                        placeholder="Your Address*" />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <input type="text"
                                        id="message"
                                        value={message}
                                        onChange={(e)=>setMessage(e.target.value)}
                                        placeholder="Your Message"
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <button type="submit" onClick={submitMessage}>Submit</button>
                                </td>
                            </tr>

                        </table>
                    </form>

                </div>
            </section>
        </>
    )
}
export default Connect;